import { html, LitElement } from 'lit';
import { TagKey } from '@cof/tag-catalog-fs-lienholder-mfe';
import { style } from './lender-account-number.style.js';
import { DebugService } from '@services/debug.service';
import { stratum } from '../../../constants/stratum.js';
import { LenderService } from '@services/lender.service';
import '@cof/fs-text-field-wc/fs-text-field.js';
import { customElement } from 'lit/decorators.js';

@customElement('refi-lender-account-number')
export class RefiLenderAccountNumberComponent extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiLenderAccountNumber');
    this.lenderInfo = {};
  }

  static properties = {};

  static styles = [style];

  debug: DebugService;
  lenderInfo: any;

  connectedCallback() {
    super.connectedCallback();
    this.lenderInfo = LenderService.getLienholder();
  }

  render() {
    this.debug.log('rendered lender-name');
    return html`
      <div class="lender__account_number">
        <fs-text-field
          id="lenderAccountNumber"
          autocomplete="off"
          name="lenderAccountNumber"
          type="text"
          value-missing-message="Please enter your account number"
          helper="This should be account number associated with your lender"
          maxLength="50"
          pattern="([0-9a-zA-Z]|-){4,}"
          required
          @blur="${this.manualFillLienholderAccountNumber}"
          value="${this.lenderInfo.lienHolderAccountNumber}"
          pattern-mismatch-message="Your lender account number must be at least 4 characters long, and can only contain letters, numbers, and hyphen characters."
        >
          <slot name="lenderAccountNumber">Account number</slot>
        </fs-text-field>
      </div>
    `;
  }

  manualFillLienholderAccountNumber(e: any) {
    this.debug.log('lienholder account number on blur');
    this.dispatchEvent(new CustomEvent('unsaved-fields'));
    if (e && !e.currentTarget.checkValidity()) {
      stratum.publishTag(TagKey.LIENHOLDER_FIELD_VALIDATION_ERROR_MESSAGE, {
        replacements: {
          value: 'account number',
        },
      });
    }
    stratum.publishTag(TagKey.LIENHOLDER_ACCOUNT_NUMBER_EDITED);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'refi-lender-account-number': RefiLenderAccountNumberComponent;
  }
}
